import apiPaths from '../api-paths.js';

export default {
  export(params = {}) {
    return axios
      .post(
        `${ apiPaths.BOOKKEEPING }/evidences/export/symfonia`,
        params, {
          responseType: 'arraybuffer',
        },
      );
  },

};
